import React, { Component, forwardRef } from 'react';
import TreeNode from './TreeNode';
import './TreeView.css';

class TreeViewComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      treeData: [],
      showModal: false,
      newBranchName: '',
    };

    this.fetchTreeData = this.fetchTreeData.bind(this);
    this.handleAddRootBranch = this.handleAddRootBranch.bind(this);
    this.createBranch = this.createBranch.bind(this);
  }

  // Метод для загрузки данных дерева
  async fetchTreeData() {
    try {
      console.log(`${process.env.REACT_APP_BACKEND_URL}`);
      const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/Tree/GetTree`);
      const data = await response.json();
      console.log('Tree data fetched:', data);
      this.setState({ treeData: data });
    } catch (error) {
      console.error('Ошибка загрузки данных дерева:', error);
    }
  }

  componentDidMount() {
    this.fetchTreeData();
  }

  handleAddRootBranch() {
    this.setState({ showModal: true });
  }

  createBranch(parentId = null) {
    const { newBranchName } = this.state;

    if (!newBranchName.trim()) {
      alert('Название ветки не может быть пустым.');
      return;
    }

    fetch(`${process.env.REACT_APP_BACKEND_URL}/api/Node`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        name: newBranchName,
        parentId: parentId,
      }),
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error('Ошибка при создании ветки');
        }
        return response.json();
      })
      .then(() => {
        this.setState({ showModal: false, newBranchName: '' });
        this.fetchTreeData(); // Обновляем дерево
      })
      .catch((error) => {
        console.error('Ошибка при создании ветки:', error);
        alert('Не удалось создать ветку.');
      });
  }

  render() {
    const { treeData, showModal, newBranchName } = this.state;

    return (
      <div className="tree-view">
        <div className="root-add-section">
          <button className="add-root-branch" onClick={this.handleAddRootBranch}>
            +
          </button>
        </div>
        {treeData.map((node) => (
          <TreeNode
            key={node.id}
            node={node}
            onAgentClick={this.props.onAgentClick}
            onSelectNode={this.props.onSelectNode}
            onCreateSubBranch={this.createBranch}
            refreshTree={this.fetchTreeData}
          />
        ))}
        {showModal && (
          <div className="modal">
            <div className="modal-content">
              <h3>Создание Корневой Ветки</h3>
              <input
                type="text"
                value={newBranchName}
                onChange={(e) => this.setState({ newBranchName: e.target.value })}
                placeholder="Введите название ветки"
              />
              <div className="modal-actions">
                <button onClick={() => this.createBranch(null)}>Сохранить</button>
                <button onClick={() => this.setState({ showModal: false })}>Отмена</button>
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }
}

// Используем forwardRef для TreeView
const TreeView = forwardRef((props, ref) => <TreeViewComponent {...props} ref={ref} />);

export default TreeView;
